import { render, staticRenderFns } from "./feed.vue?vue&type=template&id=853e34ec&scoped=true"
import script from "./feed.vue?vue&type=script&lang=js"
export * from "./feed.vue?vue&type=script&lang=js"
import style0 from "./feed.vue?vue&type=style&index=0&id=853e34ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853e34ec",
  null
  
)

export default component.exports